import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { TextButton } from '@flipster/react/design-system/text-button';
import { Explain } from '@flipster/react/design-utils/explain';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { addPositionModalBunja } from './state';

interface Props {
  type: 'error' | 'warning';
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const ErrorMessage = ({ type, message, action }: Props) => {
  const { positionAtom } = useBunja(addPositionModalBunja);
  const prevMessageRef = useRef<string>(undefined);
  const position = useAtomValue(positionAtom);

  useEffect(() => {
    if (type !== 'error' || message === prevMessageRef.current) return;
    prevMessageRef.current = message;
    segment.track(TradeEvent.OrderFormErrorMsgView, {
      error_message: message,
      error_case: 'add_position',
      is_recommendation_chip_visible: false,
      symbol: position.symbol,
      leverage: position.initLeverage,
      order_by_token: 'margin',
    });
  }, [message, position.symbol, position.initLeverage, type]);

  switch (type) {
    case 'error': {
      return (
        <Explain.Error hideIcon css={{ display: 'inline' }}>
          {message}{' '}
          {action && (
            <TextButton
              color='sell'
              label={action.label}
              onClick={() => {
                segment.track(TradeEvent.OrderFormErrorMsgClick, {
                  error_message: message,
                  error_case: 'add_position',
                  symbol: position.symbol,
                  leverage: position.initLeverage,
                  order_by_token: 'margin',
                });
                action.onClick();
              }}
            />
          )}
        </Explain.Error>
      );
    }
    case 'warning': {
      return <Explain.Warning css={{ '& svg': { display: 'none' } }}>{message}</Explain.Warning>;
    }
    default:
      return null;
  }
};

export default ErrorMessage;
